<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Transaction Modified</div>
        <div>
          <bread-crumb :bread-crumbs="['Transaction Modified']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <div class="ms-4 subtitle-2">Log Details</div>
      <div class="d-flex ms-4">
        <v-col cols="12" md="4">
          <label class="caption">Date:</label><br />
          <label class="caption">Date Id:</label><br />
          <label class="caption">Log Type:</label><br />
        </v-col>
        <v-col cols="12" md="4">
          <label class="caption">Table:</label>
          <br />
          <label class="caption">User:</label><br />
          <label class="caption">Changes Details:</label><br />
        </v-col>
      </div>
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          dense
          class="mt-4 p-1"
        >
        </v-data-table>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Loading from "vue-loading-overlay";
// import { alpha } from "@/utils/validate"
export default {
  name: "Transaction Modified ",
  data: () => ({
    search: "",
    loader: false,

    headers: [
      {
        text: "Field",

        sortable: false,
        value: "country_code",
      },
      { text: "Old Value", value: "currency_code" },
      { text: "New Value", value: "currency_code", sortable: false },
    ],

    desserts: [
      {
        country_code: "code",
        currency_code: "Service Free-ban Cash",
      },
    ],
  }),

  components: {
    BreadCrumb,
    Loading,
  },

  watch: {},

  //   created () {
  //     this.initialize()
  //   },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
</style>
